module.exports = __webpack_public_path__ + "static/img/组 73(1).65378dc9.png";